import axios from "axios";
const jsonConfig = require("../../config.json");


const updateTemporaryPasswordResponse = async (payload) => {
    let allResponse = {}
    try {
        const Response = await  axios.put(
            jsonConfig.apiUrl + "updatetemporaypassword",payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );
        
        allResponse = Response;
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default updateTemporaryPasswordResponse;